module.exports = __webpack_public_path__ + "assets/img/promiseImg (3).5d519995.png";